import React from 'react';
import PropTypes from 'prop-types';

import styles from '../CardContent/styles/styles.module.scss';
import CardDate from '../CardDate';
import CardName from '../CardName';
import StarRating from '../../shared/StarRating';
import Tag from '../../shared/Tag';
import UserImageLink from '../../shared/UserImageLink';
import ProBadgeSmall from '../../../../assets/images/icons/pro-badge-small.svg';
import { ConversionsUtil } from '../../../utils/conversions_util';

const TrailUgcCardContent = ({ adminUser, className, context, created_at, item, tagNames, nameLinkSettings }) => {
  const renderTrackNameDistance = () => {
    // Currently admin-only
    if (!adminUser || item.presentationType !== 'track') {
      return null;
    }
    const distance = ConversionsUtil.metersToFormattedUserUnits(item.summaryStats.distanceTotal, context && context.displayMetric, 1);
    return (
      <span className={styles.trackNameDistance}>
        {item.name}, {distance}
      </span>
    );
  };

  let trailLink = null;
  if (nameLinkSettings) {
    trailLink = (
      <a target="_blank" href={nameLinkSettings.link} className={styles.trailLink}>
        {nameLinkSettings.name}
      </a>
    );
  }

  const name = (
    <div className={styles.nameTrailDetails}>
      {`${item.user.firstName} ${item.user.lastName}`}
      {item.user.pro && <img src={ProBadgeSmall} />}
      {nameLinkSettings && ` ${nameLinkSettings.verb} `}
      {trailLink}
    </div>
  );
  let tagsDiv = null;
  if (tagNames && tagNames.length) {
    const tags = tagNames.map(tagName => <Tag className={styles.activityTag} key={tagName} title={tagName} />);
    tagsDiv = <div className={`${styles.info}> ${styles.infoTrailDetails}`}>{tags}</div>;
  }
  return (
    <div className={[styles.content, className].join(' ')}>
      <UserImageLink className={styles.inlineBlock} context={context} user={item.user} size48 />
      <CardName className={styles.nameTrailDetails} name={name} />
      {renderTrackNameDistance()}
      <div className={styles.starsDateTrailDetails}>
        <StarRating config={item.rating} />
        <CardDate className={styles.dateTrailDetails} dateString={created_at} locale={context ? context.languageRegionCode : 'en-US'} />
      </div>
      {tagsDiv}
    </div>
  );
};

TrailUgcCardContent.propTypes = {
  adminUser: PropTypes.bool,
  tagNames: PropTypes.array,
  className: PropTypes.string,
  context: PropTypes.shape({
    displayMetric: PropTypes.bool,
    languageRegionCode: PropTypes.string
  }),
  created_at: PropTypes.string,
  item: PropTypes.shape({
    presentationType: PropTypes.string,
    rating: PropTypes.number,
    user: PropTypes.object.isRequired
  }).isRequired
};

export default TrailUgcCardContent;
